module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.edit) ? _c('div', [_c('span', {
    staticClass: "title is-bold"
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-pencil",
    on: {
      "click": function($event) {
        return _vm.setEdit()
      }
    }
  })]) : _c('div', [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.saveEdit()
      }
    }
  }, [_vm._v("   ")]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-close is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("   ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f947860","hasScoped":true}!./src/components/editable-name/template.html
// module id = 400
// module chunks = 1